import { useState } from "react";
import { Instagram, MessageCircle, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, SOCIALS } from "../lib/api";

export const JoinTribe = () => {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\+?\d{10,13}$/.test(phone.replace(/\s/g, ""))) {
      toast.error("Enter a valid mobile number");
      return;
    }
    setLoading(true);
    try {
      await api.join({ phone, name: name || null });
      toast.success("You're in. Welcome to the Tribe.");
      setPhone("");
      setName("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="tribe" data-testid="join-tribe" className="bg-green-tribe text-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <p className="text-xs uppercase tracking-[0.2em] text-cream/60 mb-6">No spam, only invitations</p>
        <h2 className="font-serif font-light text-5xl sm:text-6xl md:text-7xl leading-none tracking-tight max-w-4xl">
          Join the Tribe. Get first dibs on every table.
        </h2>

        <form onSubmit={submit} data-testid="join-form" className="mt-12 grid grid-cols-1 sm:grid-cols-[1fr_1.4fr_auto] gap-3 max-w-3xl">
          <input
            data-testid="join-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="First name (optional)"
            className="bg-transparent border border-cream/30 px-5 py-4 text-cream placeholder:text-cream/50 focus:border-ochre outline-none"
          />
          <input
            data-testid="join-phone-input"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Mobile number"
            className="bg-transparent border border-cream/30 px-5 py-4 text-cream placeholder:text-cream/50 focus:border-ochre outline-none"
          />
          <button
            data-testid="join-submit"
            disabled={loading}
            className="bg-ochre text-ink px-8 py-4 uppercase tracking-[0.15em] text-xs flex items-center justify-center gap-2 hover:bg-cream transition-colors disabled:opacity-60"
          >
            {loading ? "Joining..." : "Join"} <ArrowRight size={15} />
          </button>
        </form>

        <div className="mt-16 pt-10 border-t border-cream/20 flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="flex items-center gap-4">
            <a
              href={SOCIALS.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="instagram-link"
              className="flex items-center gap-2 border border-cream/30 px-5 py-3 rounded-full hover:bg-cream hover:text-ink transition-colors text-xs uppercase tracking-[0.15em]"
            >
              <Instagram size={16} /> Follow on Instagram
            </a>
            <a
              href={SOCIALS.whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid="whatsapp-link"
              className="flex items-center gap-2 border border-cream/30 px-5 py-3 rounded-full hover:bg-cream hover:text-ink transition-colors text-xs uppercase tracking-[0.15em]"
            >
              <MessageCircle size={16} /> WhatsApp Community
            </a>
          </div>
          <p className="font-serif italic text-2xl text-cream/70">Find your +1 in the real world.</p>
        </div>
      </div>
    </section>
  );
};

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-cream/70">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 flex flex-col md:flex-row justify-between gap-6 text-sm">
      <div className="flex items-center gap-2">
        <span className="font-serif text-xl text-cream">The Plus One Tribe</span>
        <span className="text-terracotta text-xl">+</span>
      </div>
      <p className="max-w-md font-light">Curated real-world experiences across India, built for anyone 18 to 70 looking to meet good people.</p>
      <p className="text-xs uppercase tracking-[0.15em]">&copy; {new Date().getFullYear()} &middot; Made in India</p>
    </div>
  </footer>
);
